// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"295":"gameboard","650":"frontmaster"}[chunkId] + "." + {"295":"b0791a22","650":"9d6b604b"}[chunkId] + ".css";
};